import React from 'react';
import styles from './PopUpPublishDraft.module.scss';
import axiosHelper from '../../../helpers/axiosHelper';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ROUTEPATHS } from '../../../routes/routePaths';
import { DesignDetails, User } from '../../../global';
import CloseButton from '../../CloseButton/CloseButton';

interface PopUpLoginProps {
  popup: boolean;
  design: DesignDetails;
  loggedUser: User | null;
  close: () => void;
}

const PopUpPublishDraft: React.FC<PopUpLoginProps> = (props) => {
  const redirect = useNavigate();

  const publishDesign = async () => {
    if (props.loggedUser?.id === props.design.designer.id) {
      await axiosHelper.publishDraft(props.design.id, '').then((response) => {
        redirect(`/${ROUTEPATHS.COMMUNITY}/${props.loggedUser!.nameForURL}/${ROUTEPATHS.COMMUNITY_PORTFOLIO}`);
      });
    }
  };
  return (
    <Modal show={props.popup} onHide={props.close} centered contentClassName={styles.rounded}>
      <Modal.Body className={`${styles.body} bg-light-gray p-4`}>
        <div className="d-flex justify-content-end w-100">
          <CloseButton callback={props.close} />
        </div>

        <div className="mb-4 text-center">
          <span className="text-16 fw-bold">Are you sure you want to publish your design?</span>
        </div>

        <p className={`${styles.copy} text-16`}>You won't be able to edit it later.</p>

        <div className="d-flex justify-content-center mt-4">
          <button className={`${styles.actionButton} btn-success rounded mb-3`} onClick={publishDesign}>
            Publish design
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default PopUpPublishDraft;
